import React, { useState, useEffect } from 'react';
import styles from './index.module.scss';

import { useLocation, useNavigate } from 'react-router-dom';

/* img */
import Logo from '@/images/logo.png';

import GlobalState from '@/global';
import { Input, message } from "antd";
import { request } from '@/utils'
export const Index = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname, search } = location;
  const [scrollTop, setScrollTop] = useState(0);
  const { store, dispatch } = GlobalState.useContainer();
  useEffect(() => {
    window.addEventListener('scroll', (event) => {
      const eventSrcElement = event.srcElement.scrollingElement;
      if (!eventSrcElement.scrollTop) {
        setScrollTop(0);
        //处理向上使劲滚动的时候scrollTop为undefined
        return undefined;
      }
      // 滚动的高度
      const scrollTop =
        (eventSrcElement ? eventSrcElement.scrollTop : false) ||
        window.pageYOffset ||
        (eventSrcElement ? eventSrcElement.body.scrollTop : 0);
      // 视窗高度
      setScrollTop(scrollTop);
    });
  }, []);

  const getInfo = () => {
    return new Promise((resolve) => {
      request.post('register/info', {}).then(res => {
        if (res.code == 0) {
          if (res?.result?.channel) { //说明已报名
            resolve(true)
            return
          }
          resolve(false)
        }
        resolve(false)
      })
    })

  }
  return (
    <div className={styles.headerMain} style={{ background: scrollTop ? '#000' : 'transparent' }}>
      <div className={styles.content}>
        <div className={styles.left}>
          <img src={Logo} alt="" onClick={() => window.open('https://www.wanmei.com', '_blank')} />
        </div>
        <div className={styles.right}>

          <div
            className={`${styles.btn} ${pathname === '/' ? styles.active : ''}`}
            onClick={() => navigate('/')}
          >
            首页
          </div>
          <div
               className={`${styles.btn} ${pathname.includes('/top') ? styles.active : ''}`}
               >
                 获奖名单
                 <div className={styles.subBtnBox}>
                   <div
                     className={pathname.includes('/top/stu') ? styles.active : ''}
                     onClick={() => navigate('/top/stu')}
                   >
                     学生作品奖项
                   </div>
                   <div
                     className={pathname.includes('/top/tea') ? styles.active : ''}
                     onClick={() => navigate('/top/tea')}
                   >
                     指导教师奖项
                   </div>
                 </div>
               </div>
          <div
            className={`${styles.btn} ${pathname.includes('/competition') ? styles.active : ''}`}
          >
            竞赛单元
            <div className={styles.subBtnBox}>
              <div
                className={pathname.includes('/competition/recast') ? styles.active : ''}
                onClick={() => navigate('/competition/recast')}
              >
                重塑赛场
              </div>
              <div
                className={pathname.includes('/competition/mix') ? styles.active : ''}
                onClick={() => navigate('/competition/mix')}
              >
                融合赛场
              </div>
              <div
                className={pathname.includes('/competition/virtual') ? styles.active : ''}
                onClick={() => navigate('/competition/virtual')}
              >
                灵境赛场
              </div>
            </div>
          </div>
          <div
            className={`${styles.btn} ${pathname.includes('/product') ? styles.active : ''}`}
            onClick={() => navigate('/product')}
          >
            大赛作品
          </div>
          <div
            className={`${styles.btn} ${pathname === '/game' ? styles.active : ''}`}
          >
            往届赛事
            <div className={styles.subBtnBox}>
              <div
                onClick={() => window.open('https://www.wanmei.com/hd/2008/net/wenchuang2020/index.html', '_blank')}
              >
                第一届
              </div>
              <div
                onClick={() => window.open('https://www.wanmei.com/hd/2108/net/wenchuang/index.html', '_blank')}
              >
                第二届
              </div>
            </div>
          </div>
          {store.token ? <div className={styles.loginBox}>
            <div className={styles.loginBtn}>我的</div>
            <div className={styles.loginBtn}>注销</div>
            <div className={styles.subBtnBox}>
              <div
                className={pathname.includes('/home') ? styles.active : ''}
                onClick={async () => {
                  navigate('/home')
                }}
              >
                我的主页
              </div>
              <div
                className={pathname.includes('/participate') ? styles.active : ''}
                onClick={() => navigate('/participate')}
              >
                我要报名
              </div>
              <div
                className={pathname.includes('/work') ? styles.active : ''}
                onClick={async () => {
                  let result = await getInfo()
                  if (!result) {
                    message.error('您还还未报名参与比赛。')
                    return
                  }
                  navigate('/work')
                }}
              >
                参赛作品
              </div>
              <div
                onClick={() => {
                  dispatch({ type: 'set-token', payload: '' })
                  dispatch({ type: 'set-userId', payload: '' })
                  setTimeout(() => {
                    window.location.href = '#/'
                  }, 1000)
                }}
              >
                注销
              </div>
            </div>
          </div> : <div
            className={`${styles.btn} ${pathname === '/login' ? styles.active : ''}`}
            onClick={() => navigate('/login')}
          >
            登录
          </div>}
        </div>
      </div>
    </div>
  );
};

export default Index;
